<template>
  <section class="high-efficiency">
    <banner part-id="highEfficiency" />
    <div
      v-if="vm.lang !== 'zh'"
      class="section-text-background efficient-background-text-img"
      :style="backgroundTextStyle"
    >
      EFFICIENT
    </div>
    <google-lens v-if="lang !== 'zh'" />
    <nearby v-if="lang !== 'zh' && !vm.isMobile" />
    <nearby-h5 v-if="lang !== 'zh' && vm.isMobile" />
    <flashback />
    <breeno v-if="lang === 'zh'" />
    <connection v-if="lang === 'zh'" />
  </section>
</template>

<script>
import Banner from '../Banner/PartBanner';
import Flashback from './Flashback';
import Connection from './Connection';
import Breeno from './Breeno';
import GoogleLens from './googleLens';
import Nearby from './nearby';
import NearbyH5 from './nearby-h5';
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

const phaseOffsetList = [-60 / 960, 34 / 960, 0, -129 / 960, -0.125, 0, 452 / 960];
const phasePreSumList = [];
const progressList = [25, 100, 50, 87.5 + 25, 12.5, 50 + 50, 150];
const progressSum = progressList.reduce((a, b) => (b += a));
const progressBreakPoint = [];
for (let i = 0; i < progressList.length; i++) {
  progressBreakPoint[i] = (progressBreakPoint[i - 1] || 0) + progressList[i] / progressSum;
  phasePreSumList.push((phasePreSumList[i - 1] || 0) + (phaseOffsetList[i - 1] || 0));
}

export default {
  inject: ['lang', 'vm'],
  components: {
    // HightBanner,
    Banner,
    Flashback,
    Connection,
    Breeno,
    GoogleLens,
    Nearby,
    NearbyH5
  },
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      backgroundTextProgress: 0
    };
  },
  computed: {
    backgroundTextStyle() {
      if (this.vm.lang === 'zh') return false;

      const progress = this.backgroundTextProgress;
      const innerHeight = window.innerHeight;
      const currentPhase = progressBreakPoint.indexOf(
        progressBreakPoint.find(item => progress <= item) || progressBreakPoint[progressBreakPoint.length - 1]
      );
      let transY = 0;
      if (currentPhase === 0) {
        transY = (progress / progressBreakPoint[0]) * phaseOffsetList[0] * innerHeight;
      } else {
        transY =
          ((progress - progressBreakPoint[currentPhase - 1]) /
            (progressBreakPoint[currentPhase] - progressBreakPoint[currentPhase - 1])) *
            phaseOffsetList[currentPhase] *
            innerHeight +
          phasePreSumList[currentPhase] * innerHeight;
      }
      return {
        transform: `translate3d(0,${transY}px,0)`
      };
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: (progressSum / 100) * window.innerHeight,
        triggerElement: '.high-efficiency',
        offset: window.innerHeight,
        triggerHook: 0
      })
        .setPin('.efficient-background-text-img')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('backgroundTextProgress', e.progress, 200);
        });
    },
    resizeHandler() {
      if (window.innerWidth <= 734) {
        this.backgroundTextProgress = 0;
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
        }
      } else if (window.innerWidth > 734 && !this.scene) {
        if (this.lang !== 'zh') this.initScroll();
      }
      if (this.scene) this.scene.offset(window.innerHeight).duration((progressSum / 100) * window.innerHeight);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './highEfficiency.scss';
</style>
